(function ($) {
// плавная прокрутка
    $(function () {
        $('.special-landing-block a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

// основные функции посадки
    $(document).ready(function () {

        // @todo добавляем параметр ко всем ссылкам
        // @todo просмотр страницы акции - гугл пиксель и действия по кликам
        $(document).on('click', '.special-landing-block button.btn.btn-order', function (e) {
            e.preventDefault();

            var courseId = $(this).data('id');
            var target = $('.special-landing-block #order-form');
            var orderForm = $('.special-landing-block #order-form > div > form > div > div:nth-child(1) > div.common-form__course-field-wrapper > select');

            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);

            //  обновление блока с заявкой
            /*
             Игорь просил написать этот комент:
             "это грязный хак, но и так сойдет" (c)
             */
            var scope = angular.element(document.getElementsByName("orderForm")).scope();
            scope.fields.course = courseId;
            scope.$apply();
            orderForm.find('option[value=' + courseId + ']').prop('selected', true).trigger('change');

            // @todo генератор всей этой шляпы
            // будет находится тут http://apps.ekhlusov.ru/escc-landing-gen.php
            // в комметариях на странице есть полностью описание
            // @todo перенести описание в гит или вики

            return true;
        });

    });

})(jQuery);



